import { Table, Button } from "react-bootstrap";
import { FaTrash, FaPen, FaEye } from 'react-icons/fa';
import { truncateText } from "../../utils";

export default function ListView(props) {

    const {
        headers,
        data,
        handleViewFunc,
        handleDeleteFunc,
        handleEditFunc,
        showView = true,
        showDelete = true,
        showEdit = true,
        disableEditFunc,
        disableViewFunc,
        disableDeleteFunc
    } = props;



    const handleView = (id) => {
        if (typeof handleViewFunc === 'function') {
            handleViewFunc(id)
        }
    }

    const handleDelete = (id) => {
        if (typeof handleDeleteFunc === 'function') {
            handleDeleteFunc(id)
        }
    }
    const handleEdit = (id) => {
        if (typeof handleEditFunc === 'function') {
            handleEditFunc(id)
        }
    }

    return (

        <>
            {Array.isArray(data) && data.length > 0 && (<Table
                responsive className="core-ui-table">
                <thead>
                    <tr>
                        {headers.map(header => {
                            return <th className="text-left" scope="col" key={header.id}>{header.name}</th>
                        })}
                        <th scope="col"> Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(data) && data.map((ind_data) => {
                        return (<tr key={ind_data.id}>
                            {Array.isArray(headers) && headers.map(header => {
                                return (
                                    <td className="text-left" key={header.id}>
                                        {truncateText(`${(!!header.modifier ? header.modifier(ind_data[header.id]) : ind_data[header.id])} ${(!!header.suffix ? header.suffix : '')}`, 20)}
                                    </td>

                                )

                            })}
                            <td className="text-left">
                                <div
                                    className="row justify-content-center align-items-center"
                                >

                                    {showView && <div className="col-md-2"> <Button
                                        onClick={() => handleView(ind_data?.id)}
                                        disabled={typeof disableViewFunc === 'function' ? disableViewFunc(ind_data) : false}
                                        variant="link"
                                        className="dropdown-item"
                                        title="View"
                                    >
                                        <FaEye />
                                    </Button> </div>}


                                    {showDelete && <div className="col-md-2"><Button
                                        onClick={() => handleDelete(ind_data?.id)}
                                        variant="link"
                                        disabled={typeof disableDeleteFunc === 'function' ? disableDeleteFunc(ind_data) : false}
                                        className="dropdown-item text-danger"
                                        title="Delete"

                                    >
                                        <FaTrash />
                                    </Button></div>}


                                    {showEdit && <div className="col-md-2"><Button
                                        variant="link"
                                        className="dropdown-item"
                                        disabled={typeof disableEditFunc === 'function' ? disableEditFunc(ind_data) : false}
                                        onClick={() => handleEdit(ind_data?.id)}
                                        title="Edit"
                                    >
                                        {/* <i className="ri-pencil-fill mr-2"></i> */}
                                        <FaPen />
                                    </Button></div>}

                                </div>

                            </td>
                        </tr>)
                    })}

                    {!Array.isArray(data) && (<tr><td> No Data Found </td></tr>)}
                </tbody>
            </Table>)}
        </>

    )
}